"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const zustand_1 = require("zustand");
const sideBarOpenStateStore = (0, zustand_1.create)()(set => ({
    isOpen: false,
    setOpen(state) {
        set(() => ({ isOpen: state }));
    },
}));
exports.default = sideBarOpenStateStore;
